import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-faq-request',
  templateUrl: './faq-request.component.html',
  styleUrls: ['./faq-request.component.css']
})
export class FaqRequestComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
